import React, { useEffect, useState } from 'react';
import { Button, FilterWidget, FormRangePicker, MasterDetailForm, Widget } from '@digital/ui';
import {
  Demanda,
  getDemandasDemandante,
  getDemandasDemandanteConcluido,
  getDemandasPreSuprimentosConcluido,
} from '@app/api/demanda';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import GridDemandas from './GridDemandas';

const DemandasConcluido = (props: any) => {
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);
  const { usuarioPreSuprimentosOuAdmContratos } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const onUpdate = () => {
    setUpdate(!update);
  };

  //useEffect(() => {
  //  if (usuarioPreSuprimentosOuAdmContratos) {
  //    getDemandasPreSuprimentosConcluido({ periodoInicio, periodoFim }).then(data => {
  //      if (data) {
  //        setDados(data);
  //      }
  //    });
  //  } else {
  //    getDemandasDemandanteConcluido({ periodoInicio, periodoFim }).then(data => {
  //      if (data) {
  //        setDados(data);
  //      }
  //    });
  //  }
  //}, [update]);

  const listarDemandas = (
    pagination: { current?: number; pageSize?: number } = {},
    filters?: Record<string, (string | number)[] | null>,
    sorter?: any,
  ) => {
    const { current = 1, pageSize = 10 } = pagination;
    const filtroBase = {
      PreSuprimentos: usuarioPreSuprimentosOuAdmContratos,
      ConcluidoCancelado : true,
      PeriodoInicio : periodoInicio,
      PeriodoFim : periodoFim,
    };

    getDemandasDemandante(filtroBase, current, pageSize, filters, sorter).then(data => {
      if (data) {
        setDados(data.items);
        setPageSize(data.pageSize);
        setTotalPage(data.totalPages);
        setTotalItems(data.totalItems);
      }
    });
  };

  useEffect(() => {
    listarDemandas();
  }, [update]);

  return (
    <>
      <FilterWidget
        title="Filtro"
        key="filterWidget"
        actions={[
          <Button type="primary" key="filterBtn" onClick={() => onUpdate()}>
            Pesquisar
          </Button>,
        ]}>
        <MasterDetailForm>
          <FormRangePicker
            value={[periodoInicio, periodoFim]}
            startName="dataInicio"
            endName="dataFinal"
            format={dateFormat}
            label="Período"
            span={4}
            onChange={dates => {
              setPeriodoInicio(dates[0]);
              setPeriodoFim(dates[1]);
            }}
          />
        </MasterDetailForm>
      </FilterWidget>
      <Widget title="Concluídos / Cancelados">
        <GridDemandas
          dados={dados}
          currentPage={currentPage}
          pageSize={pageSize}
          totalPage={totalPage}
          totalItens={totalItems}
          fetchData={listarDemandas}
        />
      </Widget>
    </>
  );
};
export default DemandasConcluido;
